import { useStore } from 'src/contexts/StoreContext';
import { useCallback } from 'react';
import { IGroupModel } from 'src/store/_models/group';

export const useBottomSheetGroupTabsLogic = () => {
  const {
    project: { activeProject, activeGroup, switchToGroup, setShowAddProductMobile, isUploading },
    bottomSheet: { closeBottomSheet },
    i18n,
  } = useStore();

  const groups = activeProject?.filteredGroups ?? [];

  const getGroupTitle = (group: IGroupModel) => {
    return `${i18n.t(`groups:${group?.code}-title`)} ${i18n.t(group.isHappyCaseOrPhotoKit ? group.titleSuffix.trimStart() : `group-suffix:${group.titleSuffix.trimStart()}`)}`;
  };

  const onPressGroup = useCallback((groupId: string) => {
    switchToGroup({ groupId, scrollTo: 'top' });
    closeBottomSheet();
  }, []);

  const addMoreProductsHandler = async () => {
    setShowAddProductMobile(true);
    closeBottomSheet();
  };

  return {
    activeGroup,
    getGroupTitle,
    onPressGroup,
    groups,
    i18n,
    addMoreProductsHandler,
    isUploading,
    closeBottomSheet,
  };
};
